// PopularServicesSection.js
import React from 'react';
import { Box, Grid, Typography, Paper, Stack, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

import Service1 from '../Assets/ServicesImages/Water Extraction & Structural Drying.png';  
import Service2 from '../Assets/ServicesImages/Emergency Roof Tarping & Leak Response.png';
import Service3 from '../Assets/ServicesImages/Mold Prevention & Remediation.png';
import Service4 from '../Assets/ServicesImages/Sewage Cleanup.png';  
import Service5 from '../Assets/ServicesImages/Content Cleaning & Pack Out.png';  
import Service6 from '../Assets/ServicesImages/Drywall & Flooring Repair.png';  
import Service7 from '../Assets/ServicesImages/Drywall & Flooring Repair.png';  


const PopularServicesSection = () => {
  const BG = '#F9F7F3';
  const GREEN = '#43934A';
  const ORANGE = '#ff7f00';

  const chips = [
    'Background checked cleaners',
    'Insurance coverage up to $1M',
    'No Contracts or Commitments'
  ];

  const cards = [
  {
    title: "Emergency Water Extraction & Drying",
    desc:
      "When water damage strikes, minutes matter. Our rapid-response team removes standing water and dries your home fast to stop mold and structural damage.",
    includesTitle: "What’s Included",
    includes: [
      "24/7 emergency water removal",
      "Industrial-grade extraction pumps",
      "LGR dehumidifiers & air movers",
      "Thermal imaging moisture detection"
    ],
    price: "24/7",
    unit: "Emergency Service",
    image:
      Service2,
    bubble:
      "https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_image_02.png"
  },

  {
    title: "Certified Mold Remediation",
    desc:
      "Protect your health and property with professional mold inspection and remediation that removes mold at the source—not just what you see.",
    includesTitle: "What’s Included",
    includes: [
      "Mold inspection & assessment",
      "Safe containment & HEPA filtration",
      "Black mold removal",
      "Moisture source identification"
    ],
    price: "Certified",
    unit: "Mold Experts",
    image:
      Service3,
    bubble:
      "https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_image_02.png"
  },

  {
    title: "Sewage & Black Water Cleanup",
    desc:
      "Sewage backups are hazardous. Our trained technicians safely remove contamination, sanitize affected areas, and restore a safe environment.",
    includesTitle: "What’s Included",
    includes: [
      "Category 3 black water extraction",
      "Biohazard sanitation & deodorization",
      "Removal of contaminated materials",
      "Full PPE & safety protocols"
    ],
    price: "24/7",
    unit: "Biohazard Cleanup",
    image:
      Service4,
    bubble:
      "https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/floating_image_02.png"
  }
];


  const ServiceCard = ({ data, flip = false }) => (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'rgba(255,255,255,0.65)',
        borderRadius: 6,
        overflow: 'visible', // allow absolute elements
        position: 'relative'
      }}
    >
      <Grid container spacing={0} alignItems="stretch">
        {/* IMAGE SIDE */}
        <Grid item xs={12} md={6} sx={{ position: 'relative' }}>
          <Box
            sx={{
              position: 'relative',
              height: '100%',
              minHeight: { xs: 320, md: 520 },
              overflow: 'visible',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: { xs: 2, md: 0 },
              order: { xs: 1, md: flip ? 2 : 1 }
            }}
          >
            {/* soft circle behind image (like template) */}
            <Box
              sx={{
                position: 'absolute',
                left: { xs: '18%', md: '12%' },
                top: { xs: '16%', md: '18%' },
                width: { xs: 120, md: 160 },
                height: { xs: 120, md: 160 },
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.85)',
                border: '1px dashed rgba(0,0,0,0.10)'
              }}
            />

            <Box
              component="img"
              src={data.image}
              alt={data.title}
              sx={{
                width: { xs: '92%', md: 550 },
                maxWidth: '100%',
                height: 'auto',
                display: 'block'
              }}
            />

            {/* floating/bubble image absolute */}
            <Box
              component="img"
              src={data.bubble}
              alt=""
              sx={{
                display: { xs: 'none', lg: 'block' },
                position: 'absolute',
                left: flip ? 'auto' : 60,
                right: flip ? 60 : 'auto',
                top: 140,
                width: 150,
                height: 'auto',
                pointerEvents: 'none',
                userSelect: 'none',
                opacity: 0.95
              }}
            />
          </Box>
        </Grid>

        {/* CONTENT SIDE */}
        <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: flip ? 1 : 2 } }}>
          <Box sx={{ p: { xs: 3, md: 7 } }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 900,
                letterSpacing: '-0.02em',
                fontSize: { xs: 30, md: 44 }
              }}
            >
              {data.title}
            </Typography>

            <Typography sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.7, maxWidth: 560 }}>
              {data.desc}
            </Typography>

            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mt: 4 }}>
              <AutoAwesomeIcon sx={{ color: GREEN }} />
              <Typography sx={{ fontWeight: 900, fontSize: 22 }}>{data.includesTitle}</Typography>
            </Stack>

            <Stack spacing={1.2} sx={{ mt: 2 }}>
              {data.includes.map((t) => (
                <Stack key={t} direction="row" spacing={1.2} alignItems="center">
                  <CheckCircleIcon sx={{ color: GREEN, fontSize: 20 }} />
                  <Typography sx={{ color: 'text.secondary' }}>{t}</Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        </Grid>
      </Grid>

      {/* PRICE TAG (absolute) */}
      <Box
        sx={{
          position: 'absolute',
          right: { xs: 14, md: 18 },
          bottom: { xs: -22, md: -26 },
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          bgcolor: '#fff',
          borderRadius: 999,
          px: 3,
          py: 1.6,
          boxShadow: '0 18px 40px rgba(0,0,0,0.10)'
        }}
      >
        <Stack direction="row" spacing={1} alignItems="baseline">
          <Typography sx={{ fontWeight: 900, fontSize: { xs: 30, md: 36 } }}>{data.price}</Typography>
          <Typography sx={{ fontWeight: 700, color: 'text.secondary' }}>{data.unit}</Typography>
        </Stack>

        <IconButton
          sx={{
            width: 52,
            height: 52,
            bgcolor: ORANGE,
            color: '#fff',
            '&:hover': { bgcolor: '#ff6f00' }
          }}
        >
          <ArrowOutwardIcon />
        </IconButton>
      </Box>
    </Paper>
  );

  return (
    <Box id="popular-services" sx={{ py: { xs: 8, md: 10 }, bgcolor: BG }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>
        {/* Title */}
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 900,
            fontSize: { xs: 34, md: 56 },
            letterSpacing: '-0.03em'
          }}
        >
          Popular Services by Rite
        </Typography>

        {/* top checks row */}
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 1.5, md: 4 }}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 3 }}
        >
          {chips.map((c) => (
            <Stack key={c} direction="row" spacing={1.2} alignItems="center">
              <CheckCircleIcon sx={{ color: GREEN }} />
              <Typography sx={{ color: 'text.secondary' }}>{c}</Typography>
            </Stack>
          ))}
        </Stack>

        {/* Cards */}
        <Stack spacing={{ xs: 5, md: 7 }} sx={{ mt: { xs: 6, md: 8 } }}>
          <ServiceCard data={cards[0]} />
          <ServiceCard data={cards[1]} flip />
          <ServiceCard data={cards[2]} />
        </Stack>
      </Box>
    </Box>
  );
};

export default PopularServicesSection;
